"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateTimePicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _lodash = _interopRequireDefault(require("lodash"));
var _DateSinglePicker = require("./DateSinglePicker");
var _clsx3 = _interopRequireDefault(require("clsx"));
var _moment = _interopRequireDefault(require("moment"));
var _Typography = require("./Typography");
var _pittaModules = require("@thingsw/pitta-modules");
var _excluded = ["day", "mobile", "onChangeDay"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: function root(props) {
      return props.mobile ? {
        overflow: "hidden",
        height: "100%"
      } : {
        height: 297
      };
    },
    container: function container(props) {
      return props.mobile ? {
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
        alignItems: "center",
        height: "100%",
        paddingRight: theme.spacing(0.25),
        marginRight: theme.spacing(0.25),
        "&::-webkit-scrollbar": {
          width: 6
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "".concat(_pittaModules.LightColors.primary["1"], "5A"),
          borderRadius: 3
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "transparent"
        }
      } : {
        display: "flex",
        overflow: "hidden",
        height: "100%"
      };
    },
    timeDiv: function timeDiv(props) {
      return _objectSpread({
        display: "flex",
        flexDirection: "column"
      }, props.mobile ? {
        height: 256,
        width: 288,
        padding: theme.spacing(0, 3.75),
        borderTop: "1px solid ".concat(_pittaModules.LightColors.primary["6"])
      } : {
        padding: theme.spacing(0, 2),
        borderLeft: "1px solid ".concat(_pittaModules.LightColors.primary["6"])
      });
    },
    timeText: {
      display: "flex",
      padding: theme.spacing(2, 0),
      justifyContent: function justifyContent(props) {
        return props.mobile ? "center" : "unset";
      }
    },
    timePickerDiv: {
      display: "flex",
      flex: 1,
      overflow: "auto",
      justifyContent: function justifyContent(props) {
        return props.mobile ? "space-between" : "unset";
      }
    },
    timeItemDiv: {
      paddingRight: theme.spacing(0.25),
      marginRight: theme.spacing(0.25),
      "&:last-child": {
        paddingRight: 0,
        marginRight: 0
      },
      overflow: "auto",
      "&::-webkit-scrollbar": {
        width: 6
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "".concat(_pittaModules.LightColors.primary["1"], "5A"),
        borderRadius: 3
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "transparent"
      }
    },
    hideScrollbarTrack: {
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "".concat(_pittaModules.LightColors.primary["1"], "00")
      }
    },
    timeItem: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: 4,
      overflowY: "auto",
      userSelect: "none"
    }
  };
});
var DateTimePicker = function DateTimePicker(props) {
  var day = props.day,
    mobile = props.mobile,
    onChangeDay = props.onChangeDay,
    restProps = _objectWithoutProperties(props, _excluded);
  var classes = useStyles(props);
  var initHourRef = (0, _react.useRef)();
  var initMinRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)("AM"),
    _useState2 = _slicedToArray(_useState, 2),
    Ampm = _useState2[0],
    setAmpm = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = _slicedToArray(_useState3, 2),
    onScrollHour = _useState4[0],
    setOnScrollHour = _useState4[1];
  var _useState5 = (0, _react.useState)({}),
    _useState6 = _slicedToArray(_useState5, 2),
    onScrollMinute = _useState6[0],
    setOnScrollMinute = _useState6[1];
  var _useState7 = (0, _react.useState)(function () {
      return _lodash.default.range(1, 13).map(function (i) {
        return /*#__PURE__*/(0, _react.createRef)();
      });
    }),
    _useState8 = _slicedToArray(_useState7, 1),
    hourRefs = _useState8[0];
  var _useState9 = (0, _react.useState)(function () {
      return _lodash.default.range(0, 60).map(function (i) {
        return /*#__PURE__*/(0, _react.createRef)();
      });
    }),
    _useState10 = _slicedToArray(_useState9, 1),
    minuteRefs = _useState10[0];
  (0, _react.useEffect)(function () {
    if (onScrollHour) {
      var timeout = setTimeout(function () {
        setOnScrollHour(undefined);
      }, 1000);
      return function () {
        clearTimeout(timeout);
      };
    }
  }, [onScrollHour]);
  (0, _react.useEffect)(function () {
    if (onScrollMinute) {
      var timeout = setTimeout(function () {
        setOnScrollMinute(undefined);
      }, 1000);
      return function () {
        clearTimeout(timeout);
      };
    }
  }, [onScrollMinute]);
  (0, _react.useEffect)(function () {
    if (day) {
      setAmpm(day.format("A"));
    }
    if (day && !initHourRef.current && !initMinRef.current) {
      var _hourRefs$current;
      initHourRef.current = parseInt(day.format("hh"));
      initMinRef.current = parseInt(day.format("mm"));
      (_hourRefs$current = hourRefs[initHourRef.current - 1].current) === null || _hourRefs$current === void 0 ? void 0 : _hourRefs$current.scrollIntoView({
        behavior: "smooth",
        block: "center"
        // inline: "start",
      });

      var timeout = setTimeout(function () {
        if (initMinRef.current) {
          var _minuteRefs$initMinRe;
          (_minuteRefs$initMinRe = minuteRefs[initMinRef.current].current) === null || _minuteRefs$initMinRe === void 0 ? void 0 : _minuteRefs$initMinRe.scrollIntoView({
            behavior: "smooth",
            block: "center"
            // inline: "start",
          });
        }
      }, 500);
      return function () {
        clearTimeout(timeout);
      };
    }
  }, [day, hourRefs, minuteRefs]);
  var handleChangeDay = function handleChangeDay(changeDay) {
    if (day && onChangeDay) {
      onChangeDay((0, _moment.default)(day).year(changeDay.year()).month(changeDay.month()).date(changeDay.date()));
    }
  };
  var handleChangeHour = function handleChangeHour(hour) {
    if (day && onChangeDay) {
      onChangeDay((0, _moment.default)(day).hour(hour + (Ampm === "AM" ? 0 : 12)));
    }
  };
  var handleChangeMinutes = function handleChangeMinutes(minute) {
    if (day && onChangeDay) {
      onChangeDay((0, _moment.default)(day).minute(minute));
    }
  };
  var handleChangeAmpm = function handleChangeAmpm(ampm) {
    setAmpm(ampm);
    if (day && onChangeDay) {
      var current = day.format("A");
      if (current === "AM" && ampm === "PM") {
        onChangeDay((0, _moment.default)(day).hour(day.hour() + 12));
      } else if (current === "PM" && ampm === "AM") {
        onChangeDay((0, _moment.default)(day).hour(day.hour() - 12));
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_DateSinglePicker.DateSinglePicker, _extends({}, restProps, {
    day: day,
    mobile: mobile,
    onChangeDay: handleChangeDay
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.timeDiv
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.timeText
  }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "Body"
  }, day === null || day === void 0 ? void 0 : day.format("hh:mm A"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.timePickerDiv
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx3.default)(classes.timeItemDiv, _defineProperty({}, classes.hideScrollbarTrack, !onScrollHour)),
    onScroll: function onScroll(e) {
      return setOnScrollHour({});
    }
  }, _lodash.default.range(1, 13).map(function (t, i) {
    var _day$format;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx3.default)("DayPicker-Day", classes.timeItem, {
        "DayPicker-Day--selected": parseInt((_day$format = day === null || day === void 0 ? void 0 : day.format("hh")) !== null && _day$format !== void 0 ? _day$format : "0") === t
      }),
      key: "hour-key-".concat(t),
      onClick: function onClick() {
        return handleChangeHour(t);
      },
      ref: hourRefs[i]
      // ref={
      //   initialHour === t
      //     ? (ref) => {
      //         ref?.scrollIntoView({
      //           behavior: "smooth",
      //           block: "nearest",
      //           inline: "start",
      //         });
      //       }
      //     : undefined
      // }
    }, t.toString().padStart(2, "0"));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx3.default)(classes.timeItemDiv, _defineProperty({}, classes.hideScrollbarTrack, !onScrollMinute)),
    onScroll: function onScroll(e) {
      return setOnScrollMinute({});
    }
  }, _lodash.default.range(0, 60).map(function (t, i) {
    var _day$format2;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx3.default)("DayPicker-Day", classes.timeItem, {
        "DayPicker-Day--selected": parseInt((_day$format2 = day === null || day === void 0 ? void 0 : day.format("mm")) !== null && _day$format2 !== void 0 ? _day$format2 : "0") === t
      }),
      key: "minutes-key-".concat(t),
      onClick: function onClick() {
        return handleChangeMinutes(t);
      },
      ref: minuteRefs[i]
    }, t.toString().padStart(2, "0"));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.timeItemDiv
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx3.default)("DayPicker-Day", classes.timeItem, {
      "DayPicker-Day--selected": Ampm === "AM"
    }),
    onClick: function onClick() {
      return handleChangeAmpm("AM");
    }
  }, "AM"), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx3.default)("DayPicker-Day", classes.timeItem, {
      "DayPicker-Day--selected": Ampm === "PM"
    }),
    onClick: function onClick() {
      return handleChangeAmpm("PM");
    }
  }, "PM"))))));
};
exports.DateTimePicker = DateTimePicker;